export default {"src":"/_next/static/media/TWFlag.6af14d69.svg","height":600,"width":900};